import {makeStyles} from '@material-ui/styles';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        flex: 1,
        maxWidth: '100%',
        width: '100%',
        paddingBottom: 0,
        paddingTop: 0,
    },
    textField: {
        flex: 1,
        maxHeight: 48,
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    inputLabel: {
        color: `${theme.palette.text.primary}`,
    },
    form: {
        paddingRight: 20
    },
    tagForm: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    spacing: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginBottom: 5,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        }
    },
    spacingActions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        marginBottom: 5
    },
    label: {
        marginLeft: 0,
        color: theme.palette.text.primary
    },
    iconButton: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.text.primary,
        '& .text-icon-button': {
            marginLeft: 5,
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            }
        },
    },
    iconButtonBadge: {
        height: '100%',
        display: 'flex',
        zIndex: 0,
        "& .MuiBadge-badge": {
            pointerEvents: 'none',
            right: 13,
            bottom: 6,
            color: theme.palette.text.secondary,
            fontSize: '0.7em',
        },
    },
    ButtonBadge: {
        display: 'flex',
        "& .MuiBadge-badge": {
            zIndex: 0,
            color: theme.palette.text.secondary,
            fontSize: '0.7em',
            right: 33,
            bottom: 8,
            pointerEvents: 'none',
            position: 'absolute',
            width: 100
        },
    },
    dropButtonPaper: {
        zIndex: 1,
        top: 40,
    },
    dropButton: {
        maxWidth: 40,
    },
    dropButtonContainer: {
        display: 'flex',
    },
    dropButtonGroup: {
        alignSelf: 'flex-end',
    },
    imgPreview: {
        position: 'relative',
        maxWidth: '100%',
        maxHeight: '100%',
        margin: '0 auto',
        display: 'block',
    },
    imgPreviewContainer: {
        position: 'relative',
        width: 102,
        height: 102,
        padding: 5,
        border: `1px solid ${theme.palette.text.secondary}`,
        borderRadius: 5,
    },
    imgPreviewName: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        padding: '0 5px',
        backgroundColor: '#00000077',
        borderRadius: 4,
        width: '100%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    imgPreviewCloseButton: {
        position: 'absolute',
        top: -5,
        right: -5,
        padding: 0,
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.text.secondary}`,
        '&:hover': {
            background: theme.palette.background.paper,
        }
    },
    inputFileContainer: {
        width: '100%',
        padding: 5,
        border: `1px solid ${theme.palette.text.secondary}`,
        borderRadius: 4,
        '&.disabled': {
            opacity: 0.4
        }
    },
    divider: {
        margin: '5px 0',
    }
});

export default styles

export const useFormStyles = makeStyles(styles)
